import React from "react";
import { createTheming } from 'react-jss';
import { Theme } from '../theming/theme';
export const ThemeContext = createTheming(React.createContext({ theme: Theme.Light }));
export const LineContext = React.createContext({ coefType: 1, appName: '' });



// WEBPACK FOOTER //
// ./src/web-frontend-components/context/AppContexts.jsx